import React from 'react';
import { cn } from '@/shared/utils/cn';
import { SidebarSectionTitleProps } from '../../types';

/**
 * ============================================
 * SIDEBAR SECTION TITLE - ATOM
 * ============================================
 * Section label for the sidebar; groups menu blocks.
 * Body XS Regular, tertiary, sentence case (no uppercase transform).
 */
export const SidebarSectionTitle: React.FC<SidebarSectionTitleProps> = ({ title, className }) => {
  return (
    <span
      className={cn(
        'ui-text-body-xs-regular ui-font-body-xs-regular',
        'ui-leading-body-xs-regular ui-tracking-body-xs ui-text-tertiary',
        className
      )}
    >
      {title}
    </span>
  );
};
